// F-MOTOR-RESERVAS.3.0.7 — Hero gráfico institucional Rede Hospeda.
// Substitui a HERO_IMG externa (Unsplash) por composição 100% interna em SVG,
// construída exclusivamente com a paleta oficial validada:
//   Azul Hospeda   #083A6B
//   Dourado Acolher #D4A652
//   Creme Claro    #F5F1E8
//   Azul Profundo  #052B50
// O símbolo oficial é reutilizado via <image href="/brand/logo-mark.svg"/> em
// baixa opacidade, servindo como marca d'água discreta — sem recriar logomarca.
// Reaproveitado por: Dashboard.jsx, PublicCheckin.jsx, PublicCheckinEmpresa.jsx.

export function BrandHero({ className = "", withMark = true, testid }) {
  return (
    <div
      className={`absolute inset-0 overflow-hidden ${className}`}
      style={{ backgroundColor: "#083A6B" }}
      data-testid={testid || "brand-hero"}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1600 600"
        preserveAspectRatio="xMidYMid slice"
        className="w-full h-full block"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* Gradiente institucional: Azul Hospeda topo → Azul Profundo base */}
          <linearGradient id="rhBg" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#083A6B" />
            <stop offset="1" stopColor="#052B50" />
          </linearGradient>

          {/* Brilho dourado sutil no canto superior direito — toque acolhedor */}
          <radialGradient id="rhGlow" cx="0.82" cy="0.08" r="0.65">
            <stop offset="0" stopColor="#D4A652" stopOpacity="0.22" />
            <stop offset="1" stopColor="#D4A652" stopOpacity="0" />
          </radialGradient>

          {/* Padrão de arcos (evocando portais / coberturas de pousada) em dourado translúcido */}
          <pattern
            id="rhArches"
            x="0"
            y="0"
            width="180"
            height="180"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M0 180 A90 90 0 0 1 180 180"
              fill="none"
              stroke="#D4A652"
              strokeOpacity="0.09"
              strokeWidth="1.25"
            />
          </pattern>
        </defs>

        {/* Base institucional */}
        <rect width="1600" height="600" fill="url(#rhBg)" />

        {/* Camada decorativa — arcos dourados discretos */}
        <rect width="1600" height="600" fill="url(#rhArches)" />

        {/* Brilho dourado superior direito */}
        <rect width="1600" height="600" fill="url(#rhGlow)" />

        {/* Dois filetes diagonais em dourado — tira institucional sutil */}
        <path
          d="M -40 540 L 1640 300"
          stroke="#D4A652"
          strokeOpacity="0.20"
          strokeWidth="1.5"
        />
        <path
          d="M -40 560 L 1640 320"
          stroke="#D4A652"
          strokeOpacity="0.10"
          strokeWidth="1"
        />

        {/* Rodapé: fio creme sutil para fechar a composição */}
        <rect x="0" y="594" width="1600" height="6" fill="#F5F1E8" fillOpacity="0.28" />

        {/* Marca d'água oficial — reutiliza o símbolo Rede Hospeda sem recriá-lo */}
        {withMark && (
          <image
            href="/brand/logo-mark.svg"
            x="1240"
            y="90"
            width="260"
            height="260"
            opacity="0.12"
            preserveAspectRatio="xMidYMid meet"
          />
        )}
      </svg>
    </div>
  );
}

export default BrandHero;
